import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

// Patch: ensure every note module includes tags in its state
export default merge(Item({}), {
    state() {
        return {
            id: null,
            title: null,
            body: null,
            course_id: null,
            activity_id: null,
            course: null,
            activity: null,
            created_at: null,
            updated_at: null,
            tags: [], // <-- Ensure tags is always present for notes
        };
    },
    getters: {
        id: state => state.id,
    },
    actions: {},
    mutations: {
        HYDRATE(state, data) {
            Object.keys(state).forEach(key => {
                if (Object.hasOwn(data, key)) state[key] = data[key];
            });
            // Removed direct assignment of tags to prevent duplication
            // if (data.tags) {
            //     state.tags = data.tags;
            // }
        },
    },
});
